/*
 * Copyright (c) 2022 EGT Digital - All rights reserved.
 *
 * File: NavigationContainer.tsx
 *
 * Written by Martin Lubenov <martin.lubenov@egt-digital.com> on  28.10.22 9:30 am.
 * Last modified: 28.10.22 9:30 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { addBuildHash } from '../api/helpers';
import { FAVORITE_SECTION_NAME, LAST_PLAYED_SECTION_NAME, LOBBY_SECTION_NAME } from '../constants';
import { useSettings } from '../contexts/SettingsContext';
import Category from './Category';
import CategoryContainer from './CategoryContainer';
import Exit from './Exit';
import Search from './Search';

const NavigationContainer = ({ onClickSearch, onClickSettings }: INavigationContainerProps) => {
    const [settings] = useSettings();
    const shouldShowCloseSettingsButton = settings.mode === 'mobile' && settings.isSettingsModalOpen;
    //We do not want to render nav container sections until all sections are loaded, otherwise we see default sections before all sections;
    if (!settings.sections.length) {
        return <></>;
    }

    return (
        <div className="egt_navigation_container">
            {settings.mode === 'mobile' && (
                <div className="sys-tabs-left landscape-only">
                    <Exit />
                </div>
            )}
            {(!(settings.mode === 'mobile') || (!settings.isSettingsModalOpen && !settings.isSearchOpen)) && (
                <CategoryContainer>
                    <Category
                        name={LOBBY_SECTION_NAME}
                        isSelected={settings.selectedSection === LOBBY_SECTION_NAME}
                    ></Category>
                    {settings.sections
                        .filter(
                            sectionSetting =>
                                sectionSetting.games.length || sectionSetting.name === LAST_PLAYED_SECTION_NAME,
                        )
                        .map((sectionSetting: any, index) => {
                            return (
                                <Category
                                    name={sectionSetting.name}
                                    isSelected={settings.selectedSection === sectionSetting.name}
                                    key={index}
                                ></Category>
                            );
                        })}
                    <Category
                        name={FAVORITE_SECTION_NAME}
                        isSelected={settings.selectedSection === FAVORITE_SECTION_NAME}
                    ></Category>
                </CategoryContainer>
            )}

            {settings.mode === 'mobile' && (
                <div className="sys-tabs landscape-only">
                    <Search active={settings.isSearchOpen} onClick={onClickSearch} />
                    <div className="egt_lobby_settings_button">
                        {shouldShowCloseSettingsButton && (
                            <img
                                src={addBuildHash(`${settings.host}/assets/portal/ui/settings_close.svg`)}
                                className="tab"
                                alt=""
                                onClick={onClickSettings}
                            />
                        )}
                        {!shouldShowCloseSettingsButton && (
                            <img
                                src={addBuildHash(`${settings.host}/assets/portal/ui/settings.svg?`)}
                                alt="egt_lobby_settings_button-icon"
                                className="tab"
                                onClick={onClickSettings}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

interface INavigationContainerProps {
    onClickSearch?: () => void;
    onClickSettings?: () => void;
}

export default NavigationContainer;
